import DateConfirmation from './DateConfirmation';

export default DateConfirmation;
